import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { updateProjectTimelineByOwner, updateProjectTimeline,
         createProjectTimelineStage, projectTimelineApprovedByApprover,
         sendUpdateProjectTimelineRequestByOwners } from '../../../../actions/projectTimelineActions'
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
// import DatePicker from "react-datepicker";
import moment from 'moment';
import DisapproveModal from '../ReusableComponent/DisapproveModal'

const Timeline = (props) => {

    const dispatch = useDispatch();
    const { user } = useSelector(state => state.auth)
    const [members, setMembers] = useState([]);
    const [inputProjectId, setInputProjectId] = useState("");
    const [inputID, setInputID] = useState("");
    const [inputStage, setInputStage] = useState("");
    // const [startDate, setStartDate] = useState(new Date());
    // const [inputStatus, setInputStatus] = useState("");
    const [inputStageOwner, setInputStageOwner] = useState();
    const [inputStageApprover, setInputStageApprover] = useState();;
    const [inputStrategyOwnerId, setInputStrategyOwnerId] = useState();
    // const [inputTimelineStrategyId, setInputTimelineStrategyId] = useState("");
    const [isOwnerApproverDisable, setIsOwnerApproverDisable] = useState(false);
    const [isApproved, setIsApproved] = useState(false);
    const [isApprover, setIsApprover] = useState(false);
    const [isOwner, setIsOwner] = useState(false);
    const [isStrategyOwnerVisible, setIsStrategyOwnerVisible] = useState(true);
    const [isStrategyOwner, setIsStrategyOwner] = useState(false);
    // const [isTextDisable, setIsTextDisable] = useState(true);
    const [isRejected, setIsRejected] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(false);
    const [showRejectModal, setAddRejectModal] = useState(false);
    const [inputProjectClientId, setInputProjectClientId] = useState("");
	const [inputFormTitle, setInputFormTitle] = useState("")
	// const[inputEdit, setInputEdit] = useState("")

    const validationSchema = yup.object().shape({
        isStrategyOwner: yup.boolean(),
        isOwner: yup.boolean(),
        stageName: yup.string().nullable().when('isStrategyOwner', { is: true, then: yup.string().required('This filed is required') }),
        dueDate: yup.date().when('isOwner', { is: true, then: yup.date().required('Filed is required') }),
        // stageStatus: yup.string().nullable().when('isOwner', { is: true, then: yup.string().required('Filed is required') }),
        stageOwner: yup.string().nullable().when('isStrategyOwner', { is: true, then: yup.string().required('Filed is required') }),
        stageApprover: yup.string().nullable().when('isStrategyOwner', { is: true, then: yup.string().required('Filed is required') }),
    });

    const { register, handleSubmit, watch, setValue, reset, formState: { errors } } = useForm({
        mode: "onBlur",
        resolver: yupResolver(validationSchema),
    });

    useEffect(() => {
        // console.log('timeline', props)
        if (props?.timeline && props?.mode === "edit") {
            setValue('stageName', props?.timeline?.strategy)
            // setValue('stageStatus', props?.timeline?.status)
            setValue('dueDate', props?.timeline?.due_date || new Date())
            setValue('stageOwner', props?.timeline?.owner_id)
            setValue('stageApprover', props?.timeline?.approver_id)
            setInputID(props?.timeline?.id);
            setInputStage(props?.timeline?.strategy)
            // setStartDate(props?.timeline?.due_date ? new Date(props?.timeline?.due_date) : new Date())
            // setInputStatus(props?.timeline?.status)
            setInputStageOwner(props?.timeline?.owner_id);
            setInputStageApprover(props?.timeline?.approver_id);
            setIsApproved(props?.timeline?.is_approved)
            setIsRejected(props?.timeline?.is_rejected)
            setInputFormTitle("Edit Stage");
			// setInputEdit("edit");
        } else {
            setValue('stageName', '')
            // setValue('stageStatus', '')
            setValue('dueDate', new Date())
            setValue('stageOwner', '')
            setValue('stageApprover', '')
            setInputID('');
            setInputStage('')
            // setStartDate(new Date())
            // setInputStatus('')
            setInputStageOwner('');
            setInputStageApprover('');
            // setInputEdit("add");
			setInputFormTitle("Add New Stage");
        }
        // setInputTimelineStrategyId(props?.data?.timeline_strategist?.timeline_strategy_id)
        setInputStrategyOwnerId(props?.strategistId)
        setInputProjectClientId(props?.data?.client_id)
        setInputProjectId(props?.data?.id)
        setMembers(props?.members)
    }, [props, props.data, props.members, props.timeline, props.mode, reset, watch, setValue]);

    useEffect(() => {
        if (user) {
            if (inputStrategyOwnerId === user.user_id) {
                setValue('isStrategyOwner', true)
                setIsStrategyOwner(true)
                setIsStrategyOwnerVisible(false)
                // setIsTextDisable(true)
                setIsOwnerApproverDisable(false)

                setIsApprover(false)
                setIsOwner(false)
                setValue('isOwner', false)
             }
            else if (inputProjectClientId === user.user_id) {
                setIsStrategyOwnerVisible(true)
                // setIsTextDisable(true)
                setIsOwnerApproverDisable(true)
                setIsApprover(false)
            }
            else if (inputStageApprover === user.user_id && inputStageOwner === user.user_id) {
                // if (isApproved) setIsTextDisable(true);
                // else setIsTextDisable(false);
                setIsOwner(true)
                setIsApprover(true)
                setIsStrategyOwnerVisible(true)
                setValue('isOwner', true)
                setIsOwnerApproverDisable(true)
            } 
            else if (inputStageOwner === user.user_id) {
                setValue('isOwner', true)
                setIsOwner(true)
                // setIsTextDisable(false)
                setIsOwnerApproverDisable(true)
                setIsApprover(false)
            } else if (inputStageApprover === user.user_id) {
                setIsApprover(true)
                // setIsTextDisable(true)
                setIsOwnerApproverDisable(true)
                setIsOwner(false)
                setValue('isOwner', false)
            }
            else {
                setIsOwnerApproverDisable(true)
                setIsStrategyOwner(false)
                setIsStrategyOwnerVisible(true)
                // setIsTextDisable(true)
                setIsOwner(false)
                setIsApprover(false)
                setValue('isStrategyOwner', true)
                setValue('isOwner', false)
            }
        }

    }, [inputStrategyOwnerId, isApproved ,inputStageApprover, user, inputStageOwner, inputProjectClientId, setValue])

    const onMemberSubmit = async (values, e) => {
        const formData = {
            // id: inputID,
            timeline_strategy_id: inputID,
            project_id: inputProjectId,
            strategy: values.stageName,
            owner_id: values.stageOwner,
            approver_id: values.stageApprover,
        }
        const formDataOwner = {
            timeline_strategy_id: inputID,
            project_id: inputProjectId,
            due_date: moment(values.dueDate).format('YYYY-MM-DD'),
            // status: values.stageStatus,
        }

        console.log("Form values", formData);

        if (isStrategyOwner) (props.mode && props.mode === "edit") ? dispatch(updateProjectTimeline(formData)) :  dispatch(createProjectTimelineStage(formData))
        else if (isOwner) dispatch(updateProjectTimelineByOwner(formDataOwner))
        else return false;
        props.close();

    }

    // const onSelectStartDate = (date) => {
    //     setValue('dueDate', date, { shouldValidate: true })
    //     // setStartDate(date)
    // }
    const handleAddReasonClose = () => {
        setAddRejectModal(false);
        setSelectedRowData(false);
    };
    const handleReasonShow = () => {
        setSelectedRowData(inputProjectId);
        setAddRejectModal(true);
    };
    const handelRequestToEdit = () => {
        const data = { timeline_strategy_id: inputID, project_id: inputProjectId }
        dispatch(sendUpdateProjectTimelineRequestByOwners(data))
        props.close();
    };
    const handelTimelineApproved = () => {
        const data = { timeline_strategy_id: inputID.toString(), project_id: inputProjectId.toString(), is_accept: true }
        dispatch(projectTimelineApprovedByApprover(data))
        props.close();
    };
    return (
        props.open && (
        <>
            <h6 htmlFor="title" className="control-label"><strong>{ inputFormTitle }</strong></h6>
            <form className="form-auth-small" onSubmit={handleSubmit(onMemberSubmit)}>
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="stageName" className="control-label">Stage Name<span className='text-danger'>*</span></label>
                            <input
                                defaultValue={inputStage}
                                type="text"
                                disabled={isStrategyOwnerVisible}
                                name="stageName"
                                id="stageName"
                                placeholder='Enter stage name'
                                {...register('stageName')}
                                className="form-control" />
                            {errors.stageName && (
                                <div className="text-danger">{errors.stageName.message}</div>
                            )}
                        </div>
                    </div>
                    {/* <div className="col-lg-2 col-md-6 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="dueDate" className="control-label">Due Date<span className='text-danger'>*</span></label>
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => onSelectStartDate(date)}
                                name="dueDate"
                                id="dueDate"
                                disabled={isTextDisable}
                                className="form-control" />
                            {errors.dueDate && (
                                <div className="text-danger">{errors.dueDate.message}</div>
                            )}
                        </div>
                    </div> */}
                    {/* <div className="col-lg-2 col-md-6 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="status" className="control-label">Status<span className='text-danger'>*</span></label>
                            <select name="status" id="status" disabled={isTextDisable}
                                defaultValue={inputStatus}
                                {...register('stageStatus')}
                                className="form-control">
                                <option value=''>Select</option>
                                <option value='Pending'>Pending</option>
                                <option value='Ongoing'>Ongoing</option>
                                <option value='Upcoming'>Upcoming</option>
                                <option value='Completed'>Completed</option>
                                
                            </select>
                            {errors.stageStatus && (
                                <div className="text-danger">{errors.stageStatus.message}</div>
                            )}
                        </div>
                    </div> */}
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="stageOwner" className="control-label">Owner<span className='text-danger'>*</span></label>
                            <select name="stageOwner" id="stageOwner"
                                disabled={isOwnerApproverDisable}
                                // value={inputStageOwner}
                                {...register('stageOwner')}
                                className="form-control">
                                <option value=''>Select</option>
                                {members && members.map((member, index) => (
                                    <option key={index} value={member.id}>{member.name}</option>
                                ))}
                            </select>
                            {errors.stageOwner && (
                                <div className="text-danger">{errors.stageOwner.message}</div>
                            )}
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="stageApprover"
                                className="control-label"
                            >Approver<span className='text-danger'>*</span></label>
                            <select name="stageApprover" id="stageApprover" 
                                disabled={isOwnerApproverDisable}
                                // value={inputStageApprover}
                                {...register('stageApprover')}
                                className="form-control"
                            >
                                <option value=''>Select</option>
                                {members && members.map((member, index) => (
                                    <option key={index} value={member.id}>{member.name}</option>
                                ))}
                            </select>
                            {errors.stageApprover && (
                                <div className="text-danger">{errors.stageApprover.message}</div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 col-lg-12 col-sm-12 mt-3 text-center'>
                        { isOwner || isStrategyOwner ?   <button className='btn custum-bg-warning p-2 text-white' disabled={(isOwner && isApproved) ? true : false}><strong>Submit</strong></button> : null }
                        {isApprover ? <button onClick={() => handelTimelineApproved()} className='btn btn-outline-info mx-2' disabled={isApproved ? true : false} type='button'><strong>Approved</strong></button> : null}
                        {isApprover ? <button onClick={() => handleReasonShow()} className='btn btn-outline-danger mx-2' disabled={isApproved || isRejected ? true : false} type='button'><strong>Reject</strong></button> : null}
                        {isOwner && isApproved ? <button onClick={() => handelRequestToEdit()} className='btn button mx-2' disabled={isApproved === false ? true : false} type='button'><strong>Request To Edit</strong></button> : null}
                        <button className='btn btn-outline-danger p-2 mx-2' type='button' onClick={props.close}><strong>Cancel</strong></button>
                    </div>
                </div>
            </form>
            <DisapproveModal
                open={showRejectModal}
                close={handleAddReasonClose}
                data={selectedRowData}
                component={'Timeline'}
                component_id={inputID}
            />
        </>
        )
    );
};
export default Timeline;